export const roleScopes = [
    'organisation',
    'billing',
    'user',
    'device',
    'rule',
    'schedule',
    'following',
    'webhook',
    'partner',
    'application',
    'relationship',
];
